import { render, staticRenderFns } from "./mobileOrderCreate.vue?vue&type=template&id=edfbdd8a&scoped=true&"
import script from "./mobileOrderCreate.vue?vue&type=script&lang=js&"
export * from "./mobileOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./mobileOrderCreate.vue?vue&type=style&index=0&id=edfbdd8a&prod&scoped=true&lang=css&"
import style1 from "./mobileOrderCreate.vue?vue&type=style&index=1&id=edfbdd8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfbdd8a",
  null
  
)

export default component.exports